import { render, staticRenderFns } from "./BlockContact.vue?vue&type=template&id=17657f8a&"
import script from "./BlockContact.vue?vue&type=script&lang=js&"
export * from "./BlockContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports